import { render, staticRenderFns } from "./SidebarBasic.vue?vue&type=template&id=ce6fa6f4"
import script from "./SidebarBasic.vue?vue&type=script&lang=js"
export * from "./SidebarBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports